(function(global){
 'use strict';
 if(global.CeikaCoilFinancing){global.CeikaCoilFinancing.scan();return;}
 const instances=new Map();let sdk;
 function loadSdk(){
  if(sdk)return sdk;
  sdk=new Promise(resolve=>{
   if(global.affirm?.ui?.ready){global.affirm.ui.ready(()=>resolve(global.affirm));return;}
   const config={public_api_key:'6IOXPVUP6GSDGUW2',script:'https://cdn1.affirm.com/js/v2/affirm.js'};
   (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,'set');d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b='set add save post open empty reset on off trigger ready setProduct'.split(' ');a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=['get','token','url','items'];a<b.length;a++)d[b[a]]=function(){};h.async=true;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(global,config,'affirm','checkout','ui','script','ready');
   global.affirm.ui.ready(()=>resolve(global.affirm));
  });return sdk;
 }
 function amountFor(derived,pricing,market){
  const amount=Math.round(Number(derived?.totalUsd)*100);
  const expires=pricing?.expiresAt?Date.parse(pricing.expiresAt):Infinity;
  if(!(Date.now()<expires))return null;
  return derived?.pricingCurrent===true&&derived?.configurationComplete===true&&derived.currency==='USD'&&pricing?.currency==='USD'&&pricing.market?.country==='US'&&pricing.contextAligned!==false&&market?.contextAligned!==false&&Number.isSafeInteger(amount)&&amount>0?amount:null;
 }
 function scan(scope=document){
  scope.querySelectorAll('[data-coilover-preview]').forEach(root=>{
   if(instances.has(root))return;
   const order=root.querySelector('.coil-order');if(!order)return;
   const labels=JSON.parse(document.querySelector('[data-coil-financing-labels]')?.textContent||'{}');
   const box=document.createElement('div');box.className='ceika-financing ceika-coil-financing';box.hidden=true;
   const heading=document.createElement('span');heading.className='ceika-financing__label';heading.textContent=labels.heading||'';
   const promo=document.createElement('p');promo.dataset.pageType='product';box.append(heading,promo);
   const action=order.querySelector('[data-review]');action?order.insertBefore(box,action):order.append(box);
   let amount=null,timer,revision=0,events=0,quote;
   const clear=()=>{amount=null;revision++;clearTimeout(timer);box.hidden=true;promo.className='';promo.removeAttribute('data-amount');promo.replaceChildren();};
   const update=event=>{
    events++;
    quote=event.detail?.derived;
    const next=amountFor(quote,global.CoiloverPricing,global.CoiloverMarket);
    if(next===null){clear();return;}
    clearTimeout(timer);timer=setTimeout(()=>{const seen=events;try{root.dispatchEvent(new CustomEvent('coilover:request-selection'));}catch(_){clear();}if(events===seen)clear();},15000);
    if(next===amount)return;
    amount=next;const current=++revision;box.hidden=true;promo.replaceChildren();promo.className='affirm-as-low-as';promo.dataset.amount=String(amount);
    loadSdk().then(affirm=>{if(current!==revision||!root.isConnected||amount===null)return;if(amountFor(quote,global.CoiloverPricing,global.CoiloverMarket)!==amount){clear();return;}box.hidden=false;affirm.ui.refresh();});
   };
   root.addEventListener('coilover:selection',update);
   const dispose=()=>{clear();root.removeEventListener('coilover:selection',update);box.remove();instances.delete(root);};instances.set(root,dispose);
   root.dispatchEvent(new CustomEvent('coilover:request-selection'));
  });
 }
 global.CeikaCoilFinancing={scan,amountFor};
 document.addEventListener('DOMContentLoaded',()=>scan());
 document.addEventListener('shopify:section:load',event=>scan(event.target));
 document.addEventListener('shopify:section:unload',event=>{for(const[root,dispose]of instances)if(event.target.contains(root))dispose();});
 if(document.readyState!=='loading')scan();
})(window);
